import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Navigates to the selected option URL (thing manager section) inside a Turbo frame.
export default class extends Controller {
  static values = { frame: String }

  navigate(event) {
    const url = event.currentTarget.value
    if (!url) return

    const options = { action: "advance" }
    if (this.hasFrameValue && this.frameValue) {
      options.frame = this.frameValue
    }
    Turbo.visit(url, options)
  }
}
